export const GOOGLE_OAUTH_ERROR_MESSAGES: Record<string, string> = {
  cancelled:
    'You cancelled the Google sign-in. Please try again or use email to continue.',
  authentication_failed:
    'Unable to sign in with Google. Please try again or use email instead.',
  no_email_found:
    "Your Google account doesn't have an email address. Please use email to sign up.",
  token_exchange_failed:
    'Something went wrong during Google sign-in. Please try again.',
  default:
    'An error occurred with Google sign-in. Please try email authentication instead.',
};

export const getGoogleOAuthErrorMessage = (
  errorCode?: string | null,
): string | null => {
  if (!errorCode) return null;
  return (
    GOOGLE_OAUTH_ERROR_MESSAGES[errorCode] ||
    GOOGLE_OAUTH_ERROR_MESSAGES.default
  );
};
